import dynamic from 'next/dynamic';
import React from 'react';
const SecurityPage = dynamic(() => import('@/components/SecurityPage'), {
  ssr: false,
});

const Security = () => {
  return <SecurityPage />;
};

export default Security;
